import { Component } from '@angular/core';

@Component({
  selector: 'app-page-quote-review-finalize',
  templateUrl: './page-quote-review-finalize.component.html',
  standalone: false,
})
export class PageQuoteReviewFinalizeComponent {
  showAlmostDone!: boolean;
}
